import React, { useEffect } from 'react';
import { useLazyGetSignedUrlQuery } from '../../../../../api/userApi';
import { Link, Typography } from '@mui/material';
import HighlightedText from './HighlightedText';

const ChatAttachment = ({ userId, attachment: { key, type, filename }, searchQuery }) => {
  const [getSignedUrl, { data: signedUrlResult }] = useLazyGetSignedUrlQuery();

  useEffect(() => {
    (async () => {
      if (!type?.startsWith('file')) {
        return;
      }
      await getSignedUrl({ userId, key });
    })();
  }, [getSignedUrl, key, type, userId]);

  if (!signedUrlResult) {
    return null;
  }

  const { signedUrl, thumbnailSignedUrl } = signedUrlResult;

  if (type === 'file/image') {
    return (
      <Link
        href={signedUrl}
        target='_blank'
        rel='noopener noreferrer'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
      >
        <img src={thumbnailSignedUrl} alt={filename} height={150} />
        <Typography variant='body2'>
          <HighlightedText text={filename} highlight={searchQuery} />
        </Typography>
      </Link>
    );
  }
  if (['file/pdf', 'file/xlsx', 'file/csv'].includes(type)) {
    return (
      <Link href={signedUrl} target='_blank' rel='noopener noreferrer'>
        <Typography variant='body2'>
          <HighlightedText text={filename} highlight={searchQuery} />
        </Typography>
      </Link>
    );
  }

  return null;
};

export default ChatAttachment;
